/**
 * @generated SignedSource<<6771eb121eba7a9762deff9530b3679d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductRegistrationProfileStep_Checkout$data = {
  readonly id: string;
  readonly product: {
    readonly organization: {
      readonly viewerActiveMembershipPlan: {
        readonly id: string;
      } | null;
    };
  };
  readonly " $fragmentType": "ProductRegistrationProfileStep_Checkout";
};
export type ProductRegistrationProfileStep_Checkout$key = {
  readonly " $data"?: ProductRegistrationProfileStep_Checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductRegistrationProfileStep_Checkout">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductRegistrationProfileStep_Checkout",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "viewerActiveMembershipPlan",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};
})();

(node as any).hash = "d747f5aaaa60c4f6b67dbb3afb04f73a";

export default node;
